<template>
  <div class="threshold-exceeded-alert">
    <p v-if="!is_demo">
      Despite our previous warnings, the unusually high amount of activity in
      your user account persists. To avoid problems, your access to this exam
      simulator is blocked permanently.
    </p>
    <p v-if="is_demo">
      Threshold Limit Exceeded
    </p>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },

  computed: {
    ...mapState(["is_demo"])
  }
};
</script>

<style lang="scss">
.threshold-exceeded-alert {
  padding: 100px 20px;
  background-color: white;
  text-align: center;

  p {
  }
}
</style>
